import { dirname, join } from 'node:path';
import { fileURLToPath } from 'node:url';
import { existsSync } from 'node:fs';

/**
 * Resolve bundled runtime assets (SOUL.md, builtin skills) in both execution modes:
 *
 * - **Dev** (run from the source tree, e.g. `bun run src/index.tsx`): this module
 *   lives at `src/utils/`, so assets are found relative to the repo source layout.
 * - **Bundle** (`dist/index.js` produced by `scripts/build.mjs`): every module is
 *   flattened into `dist/`, and the build copies `SOUL.md` and the skills tree next
 *   to it. `existsSync` picks the bundled copy first, falling back to the dev layout.
 */
const here = dirname(fileURLToPath(import.meta.url));

/** Path to the bundled SOUL.md identity document. */
export function soulAssetPath(): string {
  const bundled = join(here, 'SOUL.md'); // dist/SOUL.md
  if (existsSync(bundled)) return bundled;
  return join(here, '../../SOUL.md'); // repo root, from src/utils
}

/** Directory that contains the builtin skill subdirectories (write-memo/, x-research/, ...). */
export function builtinSkillsDir(): string {
  const bundled = join(here, 'skills'); // dist/skills
  if (existsSync(bundled)) return bundled;
  return join(here, '../skills'); // src/skills, from src/utils
}
